import { useUnnotifiedBadges, useMarkBadgeNotified } from "@/hooks/useAchievements";
import { AchievementToast } from "./AchievementToast";

/**
 * Global component placed in AppShell.
 * Polls for unnotified badges and shows toasts one at a time.
 */
export function AchievementNotifier() {
  const { data: badges } = useUnnotifiedBadges();
  const markNotified = useMarkBadgeNotified();

  // Show only the first unnotified badge
  const badge = badges?.[0];
  if (!badge) return null;

  const handleDismiss = () => {
    markNotified.mutate(badge.badgeId);
  };

  return (
    <div className="pointer-events-none fixed bottom-20 left-0 right-0 z-50 flex justify-center px-4 md:bottom-6">
      <AchievementToast badge={badge} onDismiss={handleDismiss} />
    </div>
  );
}
